import { Provider } from 'mobx-react';
import promiseFinally from 'promise.prototype.finally';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { unregister } from './registerServiceWorker';
import stores from './Stores';

promiseFinally.shim();

const root = (
    <Provider {...stores}>
        <App />
    </Provider>
);

ReactDOM.render(root, document.getElementById('root') as HTMLElement);
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx